module.exports = __webpack_public_path__ + "img/contentdistribution.5d355f0.svg";